import React from 'react';

export default class extends React.Component{
 
  render() {
    return (
      <div style={{paddingLeft:'56px',paddingTop:'29px'}}> 
          <div>{"同步SAP失败，无法开具电子票据。"}</div>
          <div>{ "请按以下步骤进行检查："}</div>
          <div>{"  步骤1：检查是否在SAP打开该相关单据？若正在编辑，请退出；"}</div>
          <div>{"  步骤2：在APP首页点击右上角“设置”，进入后检查是否已同步，没有则点击同步；"}</div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/page/pos/getin/SyncError.tsx